import component from './dynamicsSalesTable.vue'

export default component
